import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { to: "/", label: "Inicio", testid: "nav-home" },
  { to: "/catalog", label: "Catálogo", testid: "nav-catalog" },
  { to: "/configurator", label: "Diseña tu Reloj", testid: "nav-configurator" },
  { to: "/contact", label: "Contacto", testid: "nav-contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 w-full transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md border-b border-[var(--aq-border)]" : "bg-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid grid-cols-3 items-center h-20 lg:h-24">
          <nav className="hidden lg:flex items-center gap-10">
            {navItems.slice(0, 2).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `text-[11px] uppercase tracking-[0.28em] font-medium transition-colors hover:text-black ${
                    isActive ? "text-black" : "text-[var(--aq-muted)]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex justify-center lg:justify-center justify-self-start lg:justify-self-center col-span-1">
            <Link to="/" data-testid="brand-logo" className="font-display text-2xl sm:text-3xl tracking-[0.18em]">
              AQ <span className="text-[var(--aq-gold)]">·</span> Watches
            </Link>
          </div>

          <nav className="hidden lg:flex items-center gap-10 justify-end">
            {navItems.slice(2).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `text-[11px] uppercase tracking-[0.28em] font-medium transition-colors hover:text-black ${
                    isActive ? "text-black" : "text-[var(--aq-muted)]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="lg:hidden flex justify-end col-start-3">
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen(!open)}
              className="p-2"
              aria-label="Menú"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[var(--aq-border)] bg-white">
          <nav className="max-w-7xl mx-auto px-6 py-8 flex flex-col gap-6">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-${item.testid}`}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.24em] ${isActive ? "text-black" : "text-[var(--aq-muted)]"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
